import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "toggle"];
  static values = { moreLabel: String, lessLabel: String };

  toggle() {
    this.expanded = !this.expanded;

    this.itemTargets.forEach((item) => item.classList.toggle("hidden", !this.expanded));

    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = this.expanded ? this.lessLabelValue : this.moreLabelValue;
    }
  }
}
